import {useListView} from '../../core/ListViewProvider'
import {AreasListToolbar} from './AreaListToolbar'
import {AreasListGrouping} from './AreasListGrouping'
import {AreasListSearchComponent} from './AreasListSearchComponent'

const AreasListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <AreasListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <AreasListGrouping /> : <AreasListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {AreasListHeader}
